module.exports = "/static/assets/d527a686da1975e039bf23e523bf1987.png";